/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en';
import vuexI18n from 'vuex-i18n';
import WyConstants from './library/wy-constants.js';
import WyUtils from './library/wy-utils.js';
import VueLocalStorage from 'vue-localstorage';
import VueTimers from 'vue-timers';
import { Message } from 'element-ui';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
import deepmerge from 'deepmerge';
import DatePicker from './components/widgets/date-picker/picker/date-picker';

import localeSite from './assets/languages/en/site.json';
import localeError from './assets/languages/en/error.json';
import localeButton from './assets/languages/en/button.json';
import localeAccount from './assets/languages/en/account.json';
import localeMessage from './assets/languages/en/message.json';
import localeTooltips from './assets/languages/en/tooltips.js';

import firebase from 'firebase/app';

Vue.config.productionTip = false
Vue.use(ElementUI, {locale});
Vue.use(VueLocalStorage);
Vue.use(VueTimers);
Vue.use(VueLodash, { name: 'custom' , lodash: lodash })
Vue.WyConstants = WyConstants;
Vue.WyUtils = WyUtils;
Vue.log = console.log;
Vue.error = console.error;
Vue.component('wy-date-picker', DatePicker);

(async () => {
  if(WyConstants.C1_DEV_MODE || (self.location.href.includes("host=") && self.location.href.includes("sid="))) {
    // clear session data before start a new initilaization
    //window.sessionStorage.clear();

    if(WyConstants.C1_DEV_MODE && WyConstants.C1_DEV_MODE !== true) {
      window.sessionStorage.setItem(WyConstants.SESSION_KEY_PRODUCT_NAME, WyConstants.C1_DEV_MODE);
    }
    else if(self.location.href.includes("/smartTag")) {
      window.sessionStorage.removeItem(WyConstants.SESSION_SITE_KEY_ST)
      window.sessionStorage.setItem(WyConstants.SESSION_KEY_PRODUCT_NAME, WyConstants.PRODUCT_NAME_ST);
    }
    else if(self.location.href.includes("/advSentiment")) {
      window.sessionStorage.removeItem(WyConstants.SESSION_SITE_KEY_AS)
      window.sessionStorage.setItem(WyConstants.SESSION_KEY_PRODUCT_NAME, WyConstants.PRODUCT_NAME_AS);
    }
    else if(self.location.href.includes("/autoQA")) {
      window.sessionStorage.removeItem(WyConstants.SESSION_SITE_KEY_AQ)
      window.sessionStorage.setItem(WyConstants.SESSION_KEY_PRODUCT_NAME, WyConstants.PRODUCT_NAME_AQ);
    }
    else if(self.location.href.includes("/interactions")) {
      window.sessionStorage.removeItem(WyConstants.SESSION_SITE_KEY_IA)
      window.sessionStorage.setItem(WyConstants.SESSION_KEY_PRODUCT_NAME, WyConstants.PRODUCT_NAME_IA);
    }
    else {
      window.sessionStorage.removeItem(WyConstants.SESSION_SITE_KEY_BA)
      window.sessionStorage.setItem(WyConstants.SESSION_KEY_PRODUCT_NAME, WyConstants.PRODUCT_NAME_BA);
    }
  }
  else if(self.location.href.indexOf("/#/nodata") > -1) {
    // do nothing
  }
  else {
    window.sessionStorage.setItem(WyConstants.SESSION_KEY_PRODUCT_NAME, WyConstants.PRODUCT_NAME_OC);
  }
  const productName = window.sessionStorage.getItem(WyConstants.SESSION_KEY_PRODUCT_NAME);
  let appConfigs = null, router = null, store = null;

  // SmartTag product
  if(productName == WyConstants.PRODUCT_NAME_ST) {
    appConfigs = (await import(`./config/productST.json`)).default;
    router = (await import('./routerST')).default;
    store = (await import('./store/indexST')).default;
  }
  // AdvSentiment product
  else if(productName == WyConstants.PRODUCT_NAME_AS) {
    appConfigs = (await import(`./config/productAS.json`)).default;
    router = (await import('./routerAS')).default;
    store = (await import('./store/indexAS')).default;
  }
  // AutoQA product
  else if(productName == WyConstants.PRODUCT_NAME_AQ) {
    appConfigs = (await import(`./config/productAQ.json`)).default;
    router = (await import('./routerAQ')).default;
    store = (await import('./store/indexAQ')).default;
  }
  // IA product
  else if(productName == WyConstants.PRODUCT_NAME_IA) {
    appConfigs = (await import(`./config/productIA.json`)).default;
    router = (await import('./routerIA')).default;
    store = (await import('./store/indexIA')).default;
  }
  // BA product
  else if(productName == WyConstants.PRODUCT_NAME_BA) {
    appConfigs = (await import(`./config/productBA.json`)).default;
    router = (await import('./routerBA')).default;
    store = (await import('./store/indexBA')).default;
  }
  // OC product
  else {
    appConfigs = (await import('./config/productOC.json')).default;
    router = (await import('./router')).default;
    store = (await import('./store/index')).default;
    
    let globalConfig = await store.dispatch("fetchGlobalConfiguration");
    if(globalConfig && globalConfig.authConfig && globalConfig.authConfig.firebaseConfig) {
      // Initialize Firebase
      firebase.initializeApp(globalConfig.authConfig.firebaseConfig);
    }

    // init amplitude
    let amplitudeMap = globalConfig.amplitudeMap;
    if(amplitudeMap) {
      let locationHost = location.host.replace(/\./g, '_');
      let amplitudeKey = amplitudeMap[locationHost] || amplitudeMap["default"];
      if(amplitudeKey) {
        // eslint-disable-next-line no-undef
        amplitude.getInstance().init(amplitudeKey);
      }
    }
  }
  WyConstants.SESSION_AUTH_USER = `AUTH_USER-${productName}`
    

  document.title = appConfigs.appName;
  store.commit('updateConfig', appConfigs);

  const finalLocaleSite = deepmerge(localeSite, (await import(`./assets/brands/${productName}/languages/en/site.json`)).default);
  const finalLocaleError = deepmerge(localeError, (await import(`./assets/brands/${productName}/languages/en/error.json`)).default);
  const finalLocaleButton = deepmerge(localeButton, (await import(`./assets/brands/${productName}/languages/en/button.json`)).default);
  const finalLocaleAccount = deepmerge(localeAccount, (await import(`./assets/brands/${productName}/languages/en/account.json`)).default); 
  const finalLocaleMessage = deepmerge(localeMessage, (await import(`./assets/brands/${productName}/languages/en/message.json`)).default); 
  const finalLocaleTooltips = deepmerge(localeTooltips, (await import(`./assets/brands/${productName}/languages/en/tooltips.js`)).default);

  // add en general localization
  Vue.use(vuexI18n.plugin, store);
  Vue.i18n.add('en', finalLocaleSite);
  Vue.i18n.add('en', finalLocaleError);
  Vue.i18n.add('en', finalLocaleButton);
  Vue.i18n.add('en', finalLocaleAccount);
  Vue.i18n.add('en', finalLocaleMessage);
  Vue.i18n.add('en', finalLocaleTooltips);
  Vue.i18n.set('en');

  // init branding
  import(`./assets/brands/${productName}/style.css`);

  // clean session when c1 user log out
  // if(store.getters.isC1Auth) {
  //   window.addEventListener("unload", () => {
  //     if(!window.location.keepDefaultPath) {
  //       if(!WyConstants.C1_DEV_MODE) {
  //         window.sessionStorage.clear();
  //       }
  //     }
  //   });
  // }

  // create vue app
  let vue = new Vue({
    el: '#wysdom-ai-studio',
    router,
    store,
    data: {
      locationPath: '/studio',
      unsaveDataChanages: false,
      // eslint-disable-next-line
      gitVersion: VERSION,
      // eslint-disable-next-line
      gitBranch: BRANCH,
      // eslint-disable-next-line
      gitCommitHash: COMMITHASH,
      preMsgObj: null
    },
    methods: {
      async initApp() {
        
      },
  
      isLoading() {
        return this.$children[0].pageLoading;
      },
  
      setLoading(enable) {
        if(this.$children && this.$children.length > 0) {
          this.$children[0].pageLoading = enable;
        }
      },

      isIFrameLoading() {
        return this.$children[0].iFramePageLoading;
      },

      setIFrameLoading(enable) {
        if(this.$children && this.$children.length > 0) {
          this.$children[0].iFramePageLoading = enable;
        }
      },
  
      passwordValidator(value, callback) {
        if (!value) {
          callback(Vue.i18n.translate('account.newPassword.validateEmpty'), 1);
        } else if (value.length < 8) {  
          callback(Vue.i18n.translate('account.newPassword.validateMinimum'), 1);
        } else {
          let hasLowercase = /[a-z]/.test(value);
          let hasUppercase = /[A-Z]/.test(value);
          let hasNumeric = /\d/.test(value);
          let hasSpecialChar = /[!*^?=.+\-_@#$%&]/.test(value);
          let strength = hasLowercase + hasUppercase + hasNumeric + hasSpecialChar;
          if(strength < 4) {
            callback(Vue.i18n.translate('account.newPassword.validateFormat'), strength);
          }
          else {
            callback();
          }
        }
      },
      passwordConfirm: (passwordVal, confirmVal, callback) => {
        if (!confirmVal) {
          callback(Vue.i18n.translate('account.newPasswordConfirm.validateEmpty'));
        } else if (passwordVal != confirmVal) {
          callback(Vue.i18n.translate('account.newPasswordConfirm.validateDoNotMatch'));
        } else {
          callback();
        }
      },
  
      showProcessErrorDialogue(data) {
        this.$emit("fire-page-events:processErrorDialogue", data);
      },
  
      showProcessWaitDialogue(data) {
        this.$emit("fire-page-events:processWaitDialogue", data);
      },
  
      showProcessListDrawer(data) {
        this.$emit("fire-page-events:processListDrawer", data);
      }
    },
    created() {
      // global event handler
      this.fireEvent = (data) => {
        this.$emit(`fire-page-events:${this.$route.name}`, data)
      }
      
      this.registerPageEvent = (name, callback) => {  
        this.$on(`fire-page-events:${name}`, (event) => {
          callback(event);
        })
      }
  
      this.unregisterPageEvent = (name) => {  
        this.$off(`fire-page-events:${name}`);
        this.$root.$emit(`fire-app-clickOverlayModal-events`, {handleApply: null, active: false});
      }
  
      // global notification message
      this.notificationMsg = null;
      this.hideNotification = () => {
        if(this.notificationMsg) this.notificationMsg.close();
      }
      this.showNotification = (type, title, messages, options) => {
        if(!this.notificationMsg) {
          const h = this.$createElement;
          const list = [];
          if(title) list.push(h('div', {class: "title"}, title))
          if(Array.isArray(messages)) {
            messages.forEach(message => {
              list.push(h('div', {class: "desc"}, message))
            })
          }
          else {
            list.push(h('div', {class: "desc"}, messages))
          }    
  
          this.notificationMsg = Message({ 
            type: type,
            customClass: 'wys-notification',
            showClose: (options && options.showClose) ? options.showClose : false,
            duration: (options && options.duration != null) ? options.duration : 4000,
            message: h('div', null, list),
            onClose: () => { 
              this.notificationMsg = null 
              document.body.removeEventListener('click', this.hideNotification);
            } 
          })
          //document.body.addEventListener('click', this.hideNotification);
          
          if(options && options.width) {
            this.notificationMsg.$el.style.width = `${options.width}px`;
          }
  
          if(options && options.callback) {
            if(!options.callbackInterval) options.callbackInterval = 1000;
            setTimeout(() => {
              options.callback();
            }, options.callbackInterval)
          }
        }
      }
  
      this.showNotificationLocale = (type, titleKey, messageKeys, options) => {
        let title = null;
        if(titleKey) title = this.$t(titleKey);
  
        let messages = null;
        if(Array.isArray(messageKeys)) {
          messages = [];
          messageKeys.forEach(messageKey => {
            messageKeys.push(this.$t(messageKey, (options && options.defVal) ? options.defVal : ""));
          })
        }
        else {
          messages = this.$t(messageKeys, (options && options.defVal) ? options.defVal : "");
        }
  
        this.showNotification(type, title, messages, options);
      }
    },
    render: h => h(App)
  }).$mount('#app')
  
  // for dynamic compoents lookup
  vue.requireComponent = require.context(
    // The relative path of the components folder
    './components',
    // Whether or not to look in subfolders
    true,
    // The regular expression used to match base component filenames
    /wy-.*\.(vue|js)$/
  )
})().catch(err => {
  console.error(err);
});